// import axios from "axios";

// const AssignOTService = axios.create({
//   //baseURL: "https://esystems.cdl.lk/backend/AttendMe2/",//baseURL: "https://esystems.cdl.lk/QRApp_BackEnd/api/attendance/",
//   //baseURL: "http://172.30.30.96:2500/",
//   baseURL:" http://localhost:51976/",

//   //  baseURL: "https://esystems.cdl.lk/backend/AttendMe2/attme/",
//   // baseURL:"https://esystems.cdl.lk/backend-Test/AttendMe2/attme/",
//    headers: {
//     UserId: "DTSUSER",
//     Password: "Dts@10099",
//   },

// });



// export default AssignOTService;


import axios from "axios";

const apiService = {
  getEmpJob: (date, jobIwno, location1,company) =>
    axios.get(
      `attme/GetEmpJobDetails?date=${date}&iwNo=${jobIwno}&location=${location1}&company=${company}`,
      {
        headers: {
          UserId: "DTSUSER",
          Password: "Dts@10099",
        },
      }
    ),
    getEmpOT:(date) =>
      axios.get(
      `attme/GetEmpOTDetails?date=${date}`,
      {
        headers: {
          UserId: "DTSUSER",
          Password: "Dts@10099",
        },
      }
    ),
    postAssignOt:(postData)=>
      axios.post(
        `attme/AssignOt`,postData,
         {
        headers: {
            "Content-Type": "application/json",
          UserId: "DTSUSER",
          Password: "Dts@10099",
        },
      }
    ),

    getJobVice:(location) =>
      axios.get(
      `Attme/GetJobViceEmp?Location=${location}`,
      {
        headers: {
          UserId: "DTSUSER",
          Password: "Dts@10099",
        },
      }
    ),

    getCDLHolidy:() =>
      axios.get(
      `attme/GetCDLHolidayList`,
      {
        headers: {
          UserId: "DTSUSER",
          Password: "Dts@10099",
        },
      }
    ),
};

export default apiService;

